<template>
  <div id="mainPage">
    <header>
      <Header />
    </header>
    <div v-if="isDemo()" class="contentsBox">
      <div class="messageBox">
        Coming Soon
      </div>
    </div>
    <div v-else id="Toppage">
      <div class="topInfo" :style="{ display: this.isUpdateInfoDisplayed('2021-12-14') ? 'block' : 'none' }">
        <div class="inner2">
          <template v-if="this.checkOpenExhibition()">
            <p><span class="info">INFO</span><router-link to="/sponsors/600003">協賛団体展示の美瑛町展示ページにて人気声優「石川由依」さんによる音声ガイドコンテンツを公開しました</router-link></p>
          </template>
          <template v-else>
            <p><span class="info">INFO</span><router-link to="/updateinfo">「東京カメラ部2021写真展 Online Exhibition」閉幕いたしました。</router-link></p>
          </template>
        </div><!-- /inner2-->
      </div>
      <input type="hidden" name="id" :value="todaysTagId" /><!-- 現在表示されているタグIDを設定。特に意味はないが、開発者画面で確認するために設定 -->

      <div class="mainVisual">
        <div class="imgBlock"><img class="imageOn" src="/img2021/top_tpp.jpg" srcset="/img2021/top_tpp@2x.jpg 2x" alt="TODAY'S PICK UP PHOTOS" /></div>
        <template v-for="(work, index) in works">
        <div :key="index" class="imgBlock" @click="imageLink" :data-winner-id="work.winnerId" :data-work-index="index"><img :class="{ imageOn: work.imageOn }" :src="work.imageUrlS" :alt="work.title + (work.shootingSpotName ? (' ' + work.shootingSpotName) : '')" /></div>
        </template>
      </div>

      <div class="talkShowArchive">
        <div class="inner2">
          <h2>出展者公式イベントレポート</h2>
          <p class="subH2">Official Exhibition Event Reports</p>
          <div class="talkShowTbContainer">
            <div class="talkShowTb">
              <a href="/events/report_canon/"><img src="/img_report_canon/thumbnail.jpg" srcset="/img_report_canon/ogimage.jpg 2x" alt="キヤノンマーケティングジャパン株式会社「EOS R、 EOS R5 、そして今 EOS R3 へ」"></a>
              <p>
                <a>キヤノンマーケティングジャパン株式会社<br>「EOS R、 EOS R5 、そして今 EOS R3 へ」</a>
              </p>
            </div>
            <div class="talkShowTb">
              <a href="/events/report_biei/"><img src="/img_report_biei/thumbnail.jpg" srcset="/img_report_biei/ogimage.jpg 2x" alt="美瑛町（ＮＰＯ法人 美瑛町写真映像協会）「カメラと旅する北海道・美瑛町」"></a>
              <p>
                <a>美瑛町（ＮＰＯ法人 美瑛町写真映像協会）<br>「カメラと旅する北海道・美瑛町」</a>
              </p>
            </div>
            <div class="talkShowTb">
              <a href="/events/report_raytrek/"><img src="/img_report_raytrek/thumbnail.jpg" srcset="/img_report_raytrek/ogimage.jpg 2x" alt="株式会社サードウェーブ「クリエイターPC視点 raytrekのレタッチお悩み解決Before & Afterご紹介」"></a>
              <p>
                <a>株式会社サードウェーブ<br>「クリエイターPC視点 raytrekのレタッチ<br>お悩み解決 Before & Afterご紹介」</a>
              </p>
            </div>
          </div><!-- /talkShowTbContainer-->
        </div><!-- /inner2-->
      </div>

      <div class="outline">

        <div class="inner2">
          <h2>開催概要</h2>
          <p class="subH2">About</p>
           <p class="exhDate">開催期間<br> 2021/11/3（水・祝）～2021/12/11（土）<br></p>

              <p class="mainTxt">
              2020年に東京カメラ部とその分室で11億人*1を超える人々が約3,300万作品*2の中から選んだ作品「10選2020」を中心に新作、自信作を追加。更に2012年、2013年、2014年、2015年、2016年、2017年、2018年、2019年に選ばれた10選メンバーを加えた、10選9世代による合同展示です。<br>
              <br>
              本展示の開催は今年で9回目となります。過去7回目までは、都内にて大規模展示を開催し日本全国から大勢の方にお越しいただいてきましたが、昨年8回目に引き続き今年も、新型コロナウイルス感染症（COVID-19）対策としてオンラインでの開催とさせていただきました。<br>
              <br>
              また、新型コロナウイルス感染症（COVID-19）の影響により甚大な被害を受けた日本全国の名勝地、観光業の支援の要素をより強くするため日本全国名勝地の四季写真を募集したフォトコンテスト「日本写真100景＜四季＞2021」の入選作品、多様な文化視点で捉えた日本の写真を募集した「Japan Travel Gallery Photo Contest」の入選作品、東京カメラ部Weiboアカウントにて開催した“私がおススメしたい絶景”がテーマのフォトコンテスト入選作品と東京カメラ部Weiboアカウントへのご投稿作品から選ばれた作品、さらには東京カメラ部Twitterフォトコンテストの入選作品も加え、昨年の倍以上の約634作品を展示します。<br>
              <br>
              当サイトから、オンラインですべての作品をご覧いただくことや出展者へのコメントを通じた出展者の方との交流が可能となっています。また、オンライントークショーなども予定をしています。さらに、一部の出展者の方については、みなさまへのメッセージや、展示作品以外の作品もご覧いいただくこともできますので、時間、場所を気にせず、ゆっくりとお楽しみいただけますと幸いです。
              </p>
              <p class="attention">
                *1 11億人:東京カメラ部とその分室がタイムラインで紹介している作品の2020年延べリーチ（閲覧者）数（Facebook、Instagram、Twitter、Weiboインサイト）に基づく<br>
                *2 約3,300万作品：2020年末迄に東京カメラ部とその分室に投稿いただいた総作品数
              </p>


        </div><!-- /inner2-->

        <div class="inner">
          <div class="mov01">
            <h3>東京カメラ部顧問 出井伸之よりのメッセージ</h3>
            <a><img @click="openVideoDialog" data-id="0" class="" src="/img2021/topMovieEdei.jpg" srcset="/img2021/topMovieEdei@2x.jpg 2x" alt="出井伸之よりのメッセージ" /></a>
          </div>
          <div class="mov02">
            <h3>写真展メッセージ「梶裕貴」篇</h3>
            <a><img @click="openVideoDialog" data-id="1" class="" src="/img2021/topMovieKaji.jpg" srcset="/img2021/topMovieKaji@2x.jpg 2x" alt="写真展メッセージ「梶裕貴」篇" /></a>
          </div>

          <div class="mov03">
            <h3>写真展メッセージ「石川由依」篇</h3>
            <a><img @click="openVideoDialog" data-id="2" class="" src="/img2021/topMovieIshikawa.jpg" srcset="/img2021/topMovieIshikawa@2x.jpg 2x" alt="写真展メッセージ「石川由依」篇" /></a>
          </div>

          <div class="mov04">
            <h3>写真展メッセージ「梶裕貴・石川由依」篇</h3>
            <a><img @click="openVideoDialog" data-id="3" class="" src="/img2021/topMovieComplete.jpg" srcset="/img2021/aboutMovieComplete@2x.jpg 2x" alt="写真展メッセージ" /></a>
          </div>
        </div><!-- /inner-->

        <div class="mov10v" id="t10s2020">
        <h2>10選2020からのメッセージ</h2>
          <div class="inner">
            <div class="mov01">
              <h3>photo_booooy</h3>
              <a><img @click="openVideoDialog" data-id="4" class="" src="/img2021/topMovie10v01.jpg" srcset="/img2021/topMovie10v01@2x.jpg 2x" alt="photo_booooy" /></a>
            </div>
            <div class="mov02">
              <h3>恒松泰至</h3>
              <a><img @click="openVideoDialog" data-id="5" class="" src="/img2021/topMovie10v02.jpg" srcset="/img2021/topMovie10v02@2x.jpg 2x" alt="恒松泰至" /></a>
            </div>
          </div><!-- /inner-->
        </div><!-- /mov10v-->


      </div>


      <div class="exhibition">
        <div class="exhibitionTitle">
          <div class="inner2">
            <h2>作品展示</h2>
            <p class="subH2">Exhibition</p>
          </div><!-- /inner2-->
        </div>
        
        <div class="exhibitionBody">

            <div class="exhibition10sen">
              <h3>東京カメラ部10選</h3>
              <router-link to="/t10s"><div class="imgBg">
              <img class="" src="/img2021/top_logo10sen@2x.png" alt="10選" />
              </div></router-link>
              <ul>
                <router-link to="/t10s/2020"><li>2020</li></router-link>
                <router-link to="/t10s/2019"><li>2019</li></router-link>
                <router-link to="/t10s/2018"><li>2018</li></router-link>
                <router-link to="/t10s/2017"><li>2017</li></router-link>
                <router-link to="/t10s/2016"><li>2016</li></router-link>
                <router-link to="/t10s/2015"><li>2015</li></router-link>
                <router-link to="/t10s/2014"><li>2014</li></router-link>
                <router-link to="/t10s/2013"><li>2013</li></router-link>
                <router-link to="/t10s/2012"><li>2012</li></router-link>
              </ul>

            </div>
            <div class="exhibition100kei">
              <h3>日本写真100景</h3>
              <router-link to="/j100v"><div class="imgBg">
              <img class="" src="/img2021/top_logo100kei@2x.png"  alt="日本写真100景" />
              </div></router-link>
              <ul>
                <router-link to="/j100v/hokkaido"><li>北海道</li></router-link>
                <router-link to="/j100v/tohoku"><li>東北</li></router-link>
                <router-link to="/j100v/kanto"><li>関東</li></router-link>
                <router-link to="/j100v/chubu"><li>中部</li></router-link>
                <router-link to="/j100v/kinki"><li>近畿</li></router-link>
                <router-link to="/j100v/chugoku"><li>中国</li></router-link>
                <router-link to="/j100v/shikoku"><li>四国</li></router-link>
                <router-link to="/j100v/kyushu"><li>九州</li></router-link>
                <router-link to="/j100v/okinawa"><li>沖縄</li></router-link>
                <router-link to="/j100v/overseas"><li>海外</li></router-link>
              </ul>
            </div>

            <div class="exhibitionSponsors">
              <h3>協賛団体展示</h3>
              <div class="exhibitionSponsorsBody">
                  <router-link to="/sponsors/600001"><img class="" src="/img2021/600001_profile@2x.png" alt="岩手県" /></router-link>
                  <router-link to="/sponsors/600002"><img class="" src="/img2021/600002_profile@2x.png" alt="大津市" /></router-link>
                  <router-link to="/sponsors/600009"><img class="" src="/img2021/600009_profile@2x.png" alt="キヤノンマーケティングジャパン" /></router-link>
                  <router-link to="/sponsors/600007"><img class="" src="/img2021/600007_profile@2x.png" alt="岐阜市" /></router-link>
                  <router-link to="/sponsors/600008"><img class="" src="/img2021/600008_profile@2x.png" alt="長浜市" /></router-link>
                  <router-link to="/sponsors/600011"><img class="" src="/img2021/600011_profile@2x.png" alt="浜松市" /></router-link>
                  <router-link to="/sponsors/600004"><img class="" src="/img2021/600004_profile@2x.png" alt="東川町" /></router-link>
                  <router-link to="/sponsors/600003"><img class="" src="/img2021/600003_profile@2x.png" alt="美瑛町" /></router-link>
                  <router-link to="/sponsors/600005"><img class="" src="/img2021/600005_profile@2x.png" alt="復興庁" /></router-link>
                  <router-link to="/sponsors/600006"><img class="" src="/img2021/600006_profile@2x.png" alt="横須賀市" /></router-link>
                </div>
            </div>


            <div class="exhibitionOrganizer">
              <h3>主催者企画</h3>
                  <router-link to="/organizer/twitter"><img class="" src="/img2021/top_logoTw@2x.png"  alt="Twitterフォトコンテスト" /></router-link>
                  <router-link to="/organizer/jtg"><img class="" src="/img2021/top_logoJTG@2x.png"  alt="Japan Travel Gallery Photo Contest 2021" /></router-link>
                  <router-link to="/organizer/weibo"><img class="" src="/img2021/top_logoWeibo@2x.png"  alt="Weibo" /></router-link>
            </div>

        </div><!-- /exhibitionBody-->
      </div><!-- /exhibition-->



      <div class="sponsor">
        <div class="inner">
          <p>
            【主催】<br>
            東京カメラ部株式会社<br>
            <br>
            【サポート企業】<br>
            キヤノンマーケティングジャパン株式会社、株式会社サードウェーブ、株式会社ニコンイメージングジャパン<br>
            <br>
            【協力】<br>
            岩手県、大津市、岐阜市、滋賀県 長浜市、浜松市、美瑛町（ＮＰＯ法人 美瑛町写真映像協会）、東川町/ひがしかわ観光協会、<br class="cooperationBr">復興庁、横須賀市（横須賀集客促進・魅力発信実行委員会）<br>
          </p>
        </div><!-- /inner2-->
      </div>
    </div><!-- /main-->
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>
    <YoutubeDialog :isOpen.sync="videoDialog1" url="https://www.youtube.com/embed/0C5hY9do9gw"></YoutubeDialog>
    <YoutubeDialog :isOpen.sync="videoDialog2" url="https://www.youtube.com/embed/uTq6DIIPsc8"></YoutubeDialog>
    <YoutubeDialog :isOpen.sync="videoDialog3" url="https://www.youtube.com/embed/z7S7__SDgmc"></YoutubeDialog>
    <YoutubeDialog :isOpen.sync="videoDialog4" url="https://www.youtube.com/embed/lDa-mjTHG0k"></YoutubeDialog>
    <YoutubeDialog :isOpen.sync="videoDialog5" url="https://www.youtube.com/embed/EhNZP0KwYyY"></YoutubeDialog>
    <YoutubeDialog :isOpen.sync="videoDialog6" url="https://www.youtube.com/embed/ONER5zbQ4-g"></YoutubeDialog>

  </div>
</template>
<script>
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import { TagApi } from '@/api'
import { mapGetters, mapActions } from 'vuex'
import UpButton from '@/components/modules/UpButton.vue'
import moment from 'moment-timezone'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import YoutubeDialog from '@/components/modules/YoutubeDialog.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton,
    YoutubeDialog
  },
  data () {
    return {
      // ランダム表示用作品
      works: [],
      // 表示順表
      indexList: [
        12,  17, 16, 13,  2,  6,  7, 11, 14, 10,  5, 18,  3,  4, 15,  9,  1,  8,
        8, 17, 13,  2,  1, 11,  7, 16, 15,  5,  3,  4,  6, 14, 10, 18, 12,  9,
        18,  5, 15,  6,  3,  2, 11,  10,  4,  1, 17,  7, 13, 12, 14,  9,  8, 16
      ],
      todaysTagId: null,
      // その他
      isDisplayed: false,
      timerId: null,
      nowDateTime: null,
      videoDialog1: false,
      videoDialog2: false,
      videoDialog3: false,
      videoDialog4: false,
      videoDialog5: false,
      videoDialog6: false,
    }
  },
  computed: {
    ...mapGetters([
      'winners',
      'winnersById',
    ])
  },
  methods: {
    ...mapActions([
      'setWinners',
    ]),
    isDemo () {
      return process.env.VUE_APP_DEMO_HOST ? (location.host.indexOf(process.env.VUE_APP_DEMO_HOST) >= 0) : false
    },
    // 写真展オープン中か、本番環境以外の場合、フラグにtrueを設定
    checkOpenExhibition () {
      // UNIXタイムスタンプの現在時
      const now = new Date().getTime() / 1000
      return (now <= 1639234799)
    },
    // 日付を設定すると、向こう90日間はtrueを返す
    isUpdateInfoDisplayed (startDate) {
      const date = moment(startDate).tz('Asia/Tokyo')
      date.add(90, 'days').calendar()
      return (date.format('x') >= (new Date()).getTime())
    },
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    },
    logger (type) {
      // イベント記録
      this.$ga.event('Photobook', type, 'National Geographic', null)
    },
    // 現在時刻のセット
    setNow () {
      this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      this.timerId = setInterval(function () {
        this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      }.bind(this), 1000)
    },
    isClose () {
      return true
      // return (this.nowDateTime > '20201031 23:59:59')
    },
    updateTopImages () {
      const today = new Date()
      const dateStart = new Date(2021, 10, 3) // 2021/11/3を基準日とする
      const dateNow = new Date(today.getFullYear(), today.getMonth(), today.getDate())
      let baseDays = Math.abs(Math.floor((dateNow - dateStart) / 86400000))
      baseDays = baseDays % this.indexList.length
      this.todaysTagId = this.indexList[baseDays]
      TagApi.getImages(this.todaysTagId)
        .then((result) => {
          // 2021-11-15 15:54
          // 最大件数を48件として、繰り返し無しで表示することとした
          // 端数が出た場合でも、仕方ないとのこと
          // https://tokyocameraclub.slack.com/archives/CCDC3QLF9/p1636959066119400?thread_ts=1636942069.108800&cid=CCDC3QLF9
          let tempWorks = result.winningWorks
          let baseTopPageImageCount = tempWorks.length
          if (baseTopPageImageCount > 48) baseTopPageImageCount = 48

          // ランダムに並び替え
          for (let i = 0; i < tempWorks.length; i++) {
            const idx1 = Math.floor(Math.random() * tempWorks.length)
            const idx2 = Math.floor(Math.random() * tempWorks.length)
            const temp = tempWorks[idx1]
            tempWorks[idx1] = tempWorks[idx2]
            tempWorks[idx2] = temp
          }
          this.works = tempWorks.slice(0, baseTopPageImageCount - 1) // 画像の最初が固定画像なので、全体数からマイナス1する

          // ふわっと表示
          setTimeout(() => {
            const numbers = []
            let index = 0
            this.works.map(() => {
              numbers.push(index++)
            })
            for (let i = 0; i < numbers.length; i++) {
              const idx1 = Math.floor(Math.random() * numbers.length)
              const idx2 = Math.floor(Math.random() * numbers.length)
              const temp = numbers[idx1]
              numbers[idx1] = numbers[idx2]
              numbers[idx2] = temp
            }
            index = 0
            const timerId = setInterval(() => {
              this.works.splice(numbers[index], 1, { ...this.works[numbers[index]], imageOn: true })
              index++
              if (index >= numbers.length) {
                clearInterval(timerId);
              }
            }, 10)
          }, 200)
        })
    },
    imageLink (e) {
      const winner = this.winnersById(e.currentTarget.getAttribute('data-winner-id'))
      const work = this.works[e.currentTarget.getAttribute('data-work-index')]
      if (winner.awardType == this.EnumAwardTypeTcc10Sen2020) {
        this.$router.push(`/t10s/2020/${winner.id}`)
      } else if (winner.awardType == this.EnumAwardTypeTcc10Sen2019) {
        this.$router.push(`/t10s/2019/${winner.id}`)
      } else if (winner.awardType == this.EnumAwardTypeTcc10Sen2018) {
        this.$router.push(`/t10s/2018/${winner.id}`)
      } else if (winner.awardType == this.EnumAwardTypeTcc10Sen2017) {
        this.$router.push(`/t10s/2017/${winner.id}`)
      } else if (winner.awardType == this.EnumAwardTypeTcc10Sen2016) {
        this.$router.push(`/t10s/2016/${winner.id}`)
      } else if (winner.awardType == this.EnumAwardTypeTcc10Sen2015) {
        this.$router.push(`/t10s/2015/${winner.id}`)
      } else if (winner.awardType == this.EnumAwardTypeTcc10Sen2014) {
        this.$router.push(`/t10s/2014/${winner.id}`)
      } else if (winner.awardType == this.EnumAwardTypeTcc10Sen2013) {
        this.$router.push(`/t10s/2013/${winner.id}`)
      } else if (winner.awardType == this.EnumAwardTypeTcc10Sen2012) {
        this.$router.push(`/t10s/2012/${winner.id}`)
      } else if (winner.awardType == this.EnumAwardTypeJapan100Views) {
        this.$router.push(`/j100v/${this.areaAlphabetMap[this.prefecturesMap[work.title]]}/${this.prefecturesAlphabetMap[work.title]}/${winner.id}`)
      } else if (winner.awardType == this.EnumAwardTypeTwitterSnap) {
        this.$router.push(`/organizer/twitter/snap/${winner.id}`)
      } else if (winner.awardType == this.EnumAwardTypeTwitterPoster) {
        this.$router.push(`/organizer/twitter/poster/${winner.id}`)
      } else if (winner.awardType == this.EnumAwardTypeTwitterPortrait) {
        this.$router.push(`/organizer/twitter/portrait/${winner.id}`)
      } else if (winner.awardType == this.EnumAwardTypeJtg) {
        this.$router.push(`/organizer/jtg/${winner.id}`)
      } else if (winner.awardType == this.EnumAwardTypeWeibo) {
        this.$router.push(`/organizer/weibo/${winner.id}`)
      } else if (winner.awardType == this.EnumAwardTypeSpecialExhibitons) {
        this.$router.push(`/sponsors/${winner.id}`)
      }
    },
    openVideoDialog (e) {
      const id = e.currentTarget.getAttribute('data-id')
      this.videoDialog1 = (id === "0")
      this.videoDialog2 = (id === "1")
      this.videoDialog3 = (id === "2")
      this.videoDialog4 = (id === "3")
      this.videoDialog5 = (id === "4")
      this.videoDialog6 = (id === "5")

      this.$ga.event('YouTube', 'open', id, null)
    }
  },
  created () {
    this.setNow()
    // トップページ画像読み込み
    if (!this.works || this.works.length == 0) {
      this.updateTopImages()
    }
  },
  beforeDestroy () {
    clearInterval(this.timerId)
  },
  mounted () {
    // データ読み込みが完了している場合は、タイトル表示フラグをON
    if (this.tsvLoadCompleteFlag) {
      this.isDisplayed = true
    }
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'setWinners') {
        // 読み込みが完了したら、タイトル文字を表示する
        setTimeout(() => {
          this.isDisplayed = true
        }, 1500)

        // トップページ画像情報を取得
        this.updateTopImages()
      }
    })

    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.contentsBox {
  height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.messageBox {
  margin-top: -24px;
  text-align: center;
  font-size: 3rem;
  width: 600px;
}

.titleDisplayed {
  opacity: 1;
}
</style>
